module.exports = __webpack_public_path__ + "resources/img-empty.d7638038f9b5bb11.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-error/img/img-empty.png
// module id = 509
// module chunks = 0 1 2 3 4